import { render, staticRenderFns } from "./physioDrugDetail.vue?vue&type=template&id=3a6f0fdc&scoped=true"
import script from "./physioDrugDetail.vue?vue&type=script&lang=js"
export * from "./physioDrugDetail.vue?vue&type=script&lang=js"
import style0 from "./physioDrugDetail.vue?vue&type=style&index=0&id=3a6f0fdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6f0fdc",
  null
  
)

export default component.exports